import {
    POST_BIND_ASSISTED_ORDER,
    POST_BIND_ASSISTED_ORDER_ERROR,
    CLEAN_POST_BIND_ASSISTED_ORDER,
    CLEAN_POST_BIND_ASSISTED_ORDER_ERROR,
} from "_models/redux/types";

const initialState = {
    loaded: undefined,
    method: undefined,
    payload: undefined,
    status: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case POST_BIND_ASSISTED_ORDER:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "success",
            };

        case POST_BIND_ASSISTED_ORDER_ERROR:
            return {
                ...state,
                loaded: true,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "error",
            };

        case CLEAN_POST_BIND_ASSISTED_ORDER:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "success",
            };

        case CLEAN_POST_BIND_ASSISTED_ORDER_ERROR:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "error",
            };
        default:
            return state;
    }
}
